import gql from 'graphql-tag';

export const GET_COMPANION_PLAYER_LIST = gql`
    query (
        $reserve_no: String!
    ){
        GetCompanionPlayerListFromAdmin (
            reserve_no: $reserve_no
        ){
            CompanionLists{
                reserve_no
                player_no
                member_no
                friend_id
                player_name
                mobile_number
                email
                friend_flag
                valid_flag
                pts_reserve_no
                member_class
                visited_code
                gender
                birth_date
                nickname
                era
                score_level
                profile
                enthusiasm
                companion_id
            }
        }
    }
`;

export const GET_COMPANION_PLAYER_LIST_FROM_COMPANION_REGIST = gql`
    query (
        $reserve_no: String!
    ){
        GetCompanionPlayerListFromAdmin (
            reserve_no: $reserve_no
        ){
            CompanionLists{
                reserve_no
                player_no
                member_no
                player_name
                mobile_number
                email
                friend_flag
                valid_flag
                pts_reserve_no
                gender
                birth_date
                nickname
                era
                score_level
                profile
                enthusiasm
                member_class
                visited_code
                represent_flag
            }
        }
    }
`;

export const REGIST_COMPANION_LIST = gql`
    mutation(
        $CompanionPlayerList: [CompanionPlayerList]
    ){
        RegistCompanionPlayerListFromAdmin(
            RegistCompanionLists: $CompanionPlayerList
        ){
            result
        }
    }
`;
